import { render, staticRenderFns } from "./ContestGroup.vue?vue&type=template&id=460608c2&scoped=true&"
import script from "./ContestGroup.vue?vue&type=script&lang=js&"
export * from "./ContestGroup.vue?vue&type=script&lang=js&"
import style0 from "./ContestGroup.vue?vue&type=style&index=0&id=460608c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460608c2",
  null
  
)

export default component.exports